import { render, staticRenderFns } from "./Withdrawals.vue?vue&type=template&id=cdfe58e8&"
import script from "./Withdrawals.vue?vue&type=script&lang=ts&"
export * from "./Withdrawals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports